var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	70282: () => (loadStrictSingletonVersion("default", "rxjs", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(31340))))))),
	40482: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(23620))))))),
	94087: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,21,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(9460)]).then(() => (() => (__webpack_require__(49460))))))),
	86457: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,21,0,0], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(36699))))))),
	93513: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,21,0,0], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8513))))))),
	17493: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,21,0,0], () => (__webpack_require__.e(1352).then(() => (() => (__webpack_require__(21352))))))),
	2587: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,21,0,0], () => (__webpack_require__.e(6613).then(() => (() => (__webpack_require__(16613))))))),
	1795: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,21,0,0], () => (Promise.all([__webpack_require__.e(482), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(34456))))))),
	28647: () => (loadStrictSingletonVersion("default", "@ocap/logger", false, [4,6,0,6], () => (Promise.all([__webpack_require__.e(6030), __webpack_require__.e(292)]).then(() => (() => (__webpack_require__(20292))))))),
	80467: () => (loadStrictSingletonVersion("default", "@ocap/common-services", false, [4,6,0,6], () => (Promise.all([__webpack_require__.e(482), __webpack_require__.e(7847), __webpack_require__.e(6030), __webpack_require__.e(9510), __webpack_require__.e(2587), __webpack_require__.e(415)]).then(() => (() => (__webpack_require__(30415))))))),
	36107: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/config", false, [4,20,0,0], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(79714))))))),
	87847: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [1,21,0,0], () => (Promise.all([__webpack_require__.e(2260), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(49074))))))),
	96605: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/collapse", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(77105))))))),
	5753: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/accordion", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7847), __webpack_require__.e(4478)]).then(() => (() => (__webpack_require__(84478))))))),
	94321: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/alert", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(68686))))))),
	55483: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/carousel", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(7847), __webpack_require__.e(3754)]).then(() => (() => (__webpack_require__(43754))))))),
	88135: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/datepicker", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(7847), __webpack_require__.e(1795), __webpack_require__.e(2930)]).then(() => (() => (__webpack_require__(22930))))))),
	13865: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/dropdown", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(4727)]).then(() => (() => (__webpack_require__(64727))))))),
	98305: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/modal", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(8079)]).then(() => (() => (__webpack_require__(8079))))))),
	77981: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/nav", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(7847), __webpack_require__.e(495)]).then(() => (() => (__webpack_require__(10495))))))),
	64273: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/offcanvas", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(9199)]).then(() => (() => (__webpack_require__(59199))))))),
	64795: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/pagination", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(7280)]).then(() => (() => (__webpack_require__(57280))))))),
	21557: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/popover", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(23655))))))),
	49505: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/progressbar", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(28640))))))),
	39641: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/rating", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(1795), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(82847))))))),
	37881: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/scrollspy", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(7847), __webpack_require__.e(4407)]).then(() => (() => (__webpack_require__(34407))))))),
	70765: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/timepicker", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(1795), __webpack_require__.e(6693)]).then(() => (() => (__webpack_require__(6693))))))),
	313: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/toast", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(29665))))))),
	69641: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/tooltip", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(54717))))))),
	91525: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap/typeahead", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(482), __webpack_require__.e(2482), __webpack_require__.e(7493), __webpack_require__.e(1795), __webpack_require__.e(4131)]).then(() => (() => (__webpack_require__(54131))))))),
	16030: () => (loadStrictSingletonVersion("default", "lodash-es", false, [4,4,18,1], () => (__webpack_require__.e(8315).then(() => (() => (__webpack_require__(68315))))))),
	69510: () => (loadStrictSingletonVersion("default", "@ocap/ui-utility", false, [4,6,0,6], () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(2277)]).then(() => (() => (__webpack_require__(62277))))))),
	45458: () => (loadStrictSingletonVersion("default", "@ng-bootstrap/ng-bootstrap", false, [4,20,0,0], () => (Promise.all([__webpack_require__.e(6107), __webpack_require__.e(6605), __webpack_require__.e(8835), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(48418))))))),
	80489: () => (loadStrictSingletonVersion("default", "@ocap/common-services/generic", false, [4,6,0,6], () => (__webpack_require__.e(9243).then(() => (() => (__webpack_require__(49243)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"282": [
		70282
	],
	"415": [
		45458,
		80489
	],
	"467": [
		80467
	],
	"482": [
		40482
	],
	"1795": [
		1795
	],
	"2260": [
		86457,
		93513
	],
	"2587": [
		2587
	],
	"4087": [
		94087
	],
	"6030": [
		16030
	],
	"6107": [
		36107
	],
	"6605": [
		96605
	],
	"7493": [
		17493
	],
	"7847": [
		87847
	],
	"8647": [
		28647
	],
	"8835": [
		5753,
		94321,
		55483,
		88135,
		13865,
		98305,
		77981,
		64273,
		64795,
		21557,
		49505,
		39641,
		37881,
		70765,
		313,
		69641,
		91525
	],
	"9510": [
		69510
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}